import { useState, useEffect, useCallback } from "react";
import { createFilter } from "react-select";
import { SelectOptions } from "../../../../../../../shared/interfaces/ISelectOptions";
import { CemeteryInfoApiService } from "../../../../../../../shared/services/api/cemetery-api.service";
import { Select } from "../../../../../../global";
import { INationalities } from "./IInterfaces";

interface Props {
    nationality: string;
    maxMenuHeight?: number;
}

export const Nationalities: React.FC<Props> = ({
    nationality,
    maxMenuHeight,
}) => {
    const [options, setOptions] = useState<SelectOptions[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const convertOptions = async (opts: INationalities[]) => {
        const selectOptions: SelectOptions[] = [];

        opts.forEach((element: INationalities) => {
            const option: SelectOptions = {
                label: element.designacao.toUpperCase(),
                value: element.designacao.toUpperCase(),
            };
            selectOptions.push(option);
        });
        return selectOptions;
    };

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await CemeteryInfoApiService.getNationalities();
            const op = await convertOptions(response.data);
            setOptions(op);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div>
            {!loading && (
                <Select
                    filterOption={createFilter({
                        ignoreAccents: false,
                        ignoreCase: true,
                    })}
                    defaultValue={{
                        label: nationality,
                        value: nationality,
                    }}
                    name="nacionalidadeForm"
                    label="NACIONALIDADE"
                    placeholder="Clique para selecionar..."
                    options={options}
                    maxMenuHeight={maxMenuHeight || 123}
                    isClearable
                />
            )}
        </div>
    );
};
